import BuyInvoicePaymentFormConfig from "./form";
import GenericForm from "../GenericForm";
import { BuyInvoicePaymentApi, BuyInvoicePaymentDataType } from "@/api/BuyInvoicePaymentApi";
import { useRef } from "react";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { BuyInvoicePaymentFormData, BuyInvoicePaymentRelatedAttributes } from "@/formTypes/BuyInvoicePaymentDataType";
import { BuyInvoiceDataType } from "@/api/BuyInvoiceApi";

type BuyInvoicePaymentFormProps = {
  id?: string;
  buyInvoice?: BuyInvoiceDataType;
  currencyId?: string;
  formId: string,
  saveRedirectUrl: string
}

const BuyInvoicePaymentForm = (props: BuyInvoicePaymentFormProps) => {
  const { buyInvoice } = props;
  const formRef = useRef<DynamicFormRef>(null);

  if (buyInvoice?.currencyId) {
    CurrencyIdPubSub.publish({ currencyId: buyInvoice?.currencyId, forceUpload: false })
  }

  return (
    <GenericForm<BuyInvoicePaymentFormData, BuyInvoicePaymentDataType>
      id={props.id}
      ref={formRef}
      formId={props.formId}
      defaultData={{
        buyInvoiceId: props.buyInvoice?.id,
        currencyId: `${props.buyInvoice?.currencyId}`,
        exchange_rate: props.buyInvoice?.exchange_rate
      }}
      saveRedirectUrl={props.saveRedirectUrl}
      modelRelativeObjects={BuyInvoicePaymentRelatedAttributes}
      formConfig={BuyInvoicePaymentFormConfig}
      getById={(...arg) => BuyInvoicePaymentApi.get(...arg)}
      createFn={(...arg) => BuyInvoicePaymentApi.create(...arg)}
      updateFn={(...arg) => BuyInvoicePaymentApi.update(...arg)}
      successMessage="El abono ha sido agregada correctamente a la Factura del electronica de compra"
      errorMessage="No fue posible almacenar la informacion del abono a la Factura electronica de compra"
    />
  )
}

export default BuyInvoicePaymentForm;